import React, { ReactNode } from 'react';
import { Field, Wrapper } from './styles';

export interface FormFieldProps {
  children?: ReactNode;
}

export const FormField: React.FC<FormFieldProps> = ({ children }) => {
  return (
    <Wrapper>
      <Field>{children}</Field>
    </Wrapper>
  );
};
